import { Col, Row, Typography } from "antd";

import QuestionContent from "./QuestionContent";

export default function RenderSubQuestion(props) {
	const { namePath = [], form_question_options = [], required = false } = props;

	let newNamePath = Array.isArray(namePath) ? namePath.join("_") : namePath;

	return form_question_options.map((form_question_option) => {
		return (
			<Row key={`${newNamePath}_${form_question_option.id}`}>
				<Col xs={24} sm={24} lg={24} xl={24} xxl={24}>
					<Typography.Text strong>
						{form_question_option.option}
					</Typography.Text>
				</Col>
				<Col xs={24} sm={24} lg={24} xl={24} xxl={24}>
					<QuestionContent
						namePath={[...namePath, `qo_${form_question_option.id}`]}
						question={form_question_option.question_option}
						type={form_question_option.sub_option_type}
						required={required}
						max_checkbox={form_question_option.max_checkbox}
						escape_questions={form_question_option.escape_questions}
						form_question_options={form_question_option.form_question_options}
					/>
				</Col>
			</Row>
		);
	});
}
